<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<v-app-bar
			app
			color="#EEEEEE"
			light
			elevation="0"
			prominent
			dense
			class="px-4"
			z-index="999999"
		>
			<div class="d-flex align-center">
				<v-img
					contain
					width="180"
					height="80"
					class="ml-2"
					alt="Orixe Logo"
					:src="require('../assets/Logo_Header.svg')"
				/>
			</div>

			<v-spacer />

			<!-- Guest Mode Link -->
			<v-spacer />

			<v-chip
				outlined
				class="mr-4 mt-10"
				style="
					color: #b87300;
					border: 1.5px solid #b87300;
					background: transparent;
				"
			>
				GUEST MODE
			</v-chip>
		</v-app-bar>
		<VMain>
			<v-container fluid class="pt-0">
				<v-row>
					<v-col cols="12">
						<!-- Guest Info Card -->
						<v-row class="mx-5 mt-3 mb-0">
							<v-col cols="12" class="pa-0">
								<v-card
									elevation="0"
									class="pa-5 d-flex align-center justify-space-between"
									style="border: 1.5px solid #0b7078; border-radius: 10px;"
								>
									<div class="d-flex align-center">
										<div
											class="guest-icon-wrap d-flex align-center justify-center mr-4"
											style="width:52px;height:52px;border-radius:12px;background:#e8f4f5;"
										>
											<v-icon color="#0b7078" size="28">fas fa-user</v-icon>
										</div>
										<div>
											<h3 class="mb-1">
												You are a Guest connection of {{ guestOwnerName }}
											</h3>
											<p class="mb-0" style="color:#444;max-width:560px;">
												You can submit the forms below assigned to you by {{ guestOwnerName }}. Your responses will
												be sent directly to {{ guestOwnerName }} &mdash; you will not be able to view submitted answers or any
												results.
											</p>
										</div>
									</div>
								</v-card>
							</v-col>
						</v-row>

						<!-- View Access Restricted Banner -->
						<v-row class="mx-5 mt-3 mb-0">
							<v-col cols="12" class="pa-0">
								<div
									class="d-flex align-center px-5 py-3 rounded"
									style="background:#fff9f0;border:1px solid #f5c97a;border-radius:8px;"
								>
									<v-icon color="#e6a020" class="mr-3" size="20">mdi-alert-circle-outline</v-icon>
									<span >
										<strong style="color:#b87300;">View access is restricted.</strong>
										As a guest, you can only fill and submit forms. Submitted responses, scores, and reports are visible to {{ guestOwnerName }} only.
									</span>
								</div>
							</v-col>
						</v-row>

						<!-- Assigned Forms Section -->
						<v-row
							justify="center"
							class="grey lighten-5 rounded mx-5 my-4"
							style="padding: 24px 6%;"
						>
							<v-col cols="12" class="pa-0 mb-1">
								<div class="d-flex align-center justify-space-between flex-wrap">
									<h2 class="mb-0">Assigned Forms</h2>
									<div class="d-flex align-center mt-2 mt-sm-0">
										<span class="status-dot status-dot--pending mr-2" />
										<span style="color:#666;" class="mr-4">
											Pending ({{ pendingCount }})
										</span>
										<span class="status-dot status-dot--completed mr-2" />
										<span style="color:#666;">
											Completed ({{ completedCount }})
										</span>
									</div>
								</div>
							</v-col>

							<v-col cols="12" class="pa-0 mt-3">
								<div
									v-for="form in assignedForms"
									:key="form.id"
									class="form-row d-flex align-center mb-3 px-5 py-4"
									:class="form.status === 'pending' ? 'form-row--clickable' : ''"
								>
									<!-- left accent bar -->
									<span
										class="form-row__accent mr-4"
										:style="{ background: form.status === 'pending' ? '#e6a020' : '#2e9e5b' }"
									/>

									<!-- icon -->
									<div
										class="form-icon-wrap d-flex align-center justify-center mr-4 flex-shrink-0"
										style="width:48px;height:48px;border-radius:10px;background:#e8f4f5;"
									>
										<v-img
											v-if="form.icon"
											:src="form.icon"
											width="26"
											height="26"
											contain
										/>
										<v-icon v-else color="#0b7078" size="22">fas fa-clipboard-list</v-icon>
									</div>

									<!-- title + sender -->
									<div class="form-row__main flex-grow-1">
										<div class="d-flex align-center flex-wrap">
											<h4 class="mb-0 mr-3">{{ form.title }}</h4>
											<v-chip
												x-small
												label
												:class="form.status === 'pending' ? 'chip-pending' : 'chip-completed'"
											>
												<v-icon left size="11">
													{{ form.status === 'pending' ? 'mdi-clock-outline' : 'mdi-check-circle-outline' }}
												</v-icon>
												{{ form.status === 'pending' ? 'Pending' : 'Completed' }}
											</v-chip>
										</div>

										<p class="mb-0 mt-1" style="color:#777;">
											<v-icon size="13" color="#999" class="mr-1">mdi-account-outline</v-icon>
											From {{ form.senderName }}
											<span v-if="form.status === 'completed' && form.completedOn">
												&nbsp;&middot;&nbsp;Submitted on {{ form.completedOn }}
											</span>
											<span v-else>&nbsp;&middot;&nbsp;Awaiting your response</span>
										</p>
									</div>

									<!-- action -->
									<div class="ml-4 flex-shrink-0">
										<v-btn
											v-if="form.status === 'pending'"
											depressed
											color="#0b7078"
											dark
											class="text-none"
											style="border-radius:8px;"
											@click.stop="redirect(form.path)"
										>
											Fill form
										</v-btn>
										<v-btn
											v-else
											depressed
											disabled
											class="text-none"
											style="border-radius:8px;"
										>
											<v-icon left size="15">fas fa-lock</v-icon>
											View answers locked
										</v-btn>
									</div>
								</div>
							</v-col>

							<v-col v-if="!assignedForms.length" cols="12" class="pa-0 mt-3 text-center">
								<p style="color:#777;">No forms have been assigned to you yet.</p>
							</v-col>
						</v-row>

						<v-row class="mx-5 mt-3 mb-0">
							<v-col cols="12" class="pa-0 mt-4">
								<div
									class="d-flex align-center justify-center px-5 py-4 rounded"
									style="
										background:#fff;
										border-radius:10px;
										border:1px solid #e0e0e0;
										text-align:center;
									"
								>
									<v-icon color="#0b7078" class="mr-3" size="20">mdi-information-outline</v-icon>

									<span style="color:#444;">
										Want to view your responses, scores and more?
										<a @click="registerConfirm = true" style="color:#0b7078;text-decoration:none;"><strong>Register your company on Orixe</strong></a>
										to unlock full access.
									</span>
								</div>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</VMain>
		<v-dialog v-model="registerConfirm" max-width="600px">
			<v-card class="confirm-card">
				<v-card-text class="text-center px-8 pt-10 pb-10">
					<div class="dialog-icon-wrap mx-auto mb-6">
						<v-icon size="26" color="#0b7078">fas fa-user-plus</v-icon>
					</div>

					<h2 class="mb-3">Create your account</h2>
					<p class="dialog-subtitle mb-8">
						You're currently browsing as a guest. Registering unlocks your scores, reports, and progress tracking — and this audit submission will be linked to your new account.
					</p>

					<div class="d-flex justify-center">
						<v-btn
							outlined
							color="error"
							class="px-8 mr-3"
							style="border-radius:8px;"
							@click="registerConfirm = false"
						>
							Cancel
						</v-btn>
						<v-btn
							depressed
							dark
							color="#0b7078"
							class="text-none px-8"
							@click="confirmRegister"
						>
							Yes, register me
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<test-error/>
	</v-app>
</template>

<script>
import { mapGetters } from "vuex"
import RequestAPI from "../api/audit/request"
import LoadingState from "../consts/LoadingState"

export default {
	name: "GuestPortal",
	data() {
		return {
			notificationTime: "Received just now",
			assignedForms: [],
			ownerName: null,
			registerConfirm: false,
		}
	},
	computed: {
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		clientID() {
			return this.getUser.clientID
		},
		guestOwnerName() {
			return this.ownerName || this.$route?.query?.ownerName
		},
		pendingCount() {
			return this.assignedForms.filter((f) => f.status === "pending").length
		},
		completedCount() {
			return this.assignedForms.filter((f) => f.status === "completed").length
		},
	},
	mounted() {
		this.loadGuestRequest()
	},
	methods: {
		redirect(path) {
			this.$router.push(path)
		},
		loadGuestRequest() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			RequestAPI.getGuestRequest()
				.then(result => {
					console.log("prit result", result)
					
					this.assignedForms = result.items.map(item => ({
						id: item.ID,
						title: item.TemplateName,
						senderName: item.ClientName,
						status: item.FilledOut ? "completed" : "pending",
						path: `/guestaudit/${item.ID}`,
						completedOn: item.FilledOut
							? new Date(item.AuditTimestamp).toLocaleDateString()
							: null,
						icon: null,
						template: item.Template,
						clientID: item.ClientID,
						recipient: item.Recipient,
						invitationCode: item.InvitationCode || null,
						auditID: item.AuditID,
						timestamp: item.Timestamp,
						ownerName: item.OwnerName || null,
					}))

					if (result.items.length > 0) {
						this.ownerName = result.items[0].OwnerName || null
					}

					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		confirmRegister() {
			this.registerConfirm = false
			RequestAPI.updateGuest()
				.then(() => {
					this.$router.push("/login")
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
}
</script>

<style scoped>
.form-row {
	background: #fff;
	border: 1px solid #e6e6e6;
	border-radius: 12px;
	transition: box-shadow 0.18s, transform 0.18s, border-color 0.18s;
}
.form-row--clickable:hover {
	box-shadow: 0 4px 16px rgba(11, 112, 120, 0.12) !important;
	border-color: #cfe6e8;
	transform: translateY(-1px);
}
.form-row__accent {
	display: inline-block;
	width: 4px;
	align-self: stretch;
	border-radius: 4px;
	min-height: 40px;
}
.notification-banner {
	transition: box-shadow 0.15s;
}

.status-dot {
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.status-dot--pending {
	background: #e6a020;
}
.status-dot--completed {
	background: #2e9e5b;
}

.chip-pending {
	background: #fff3df !important;
	color: #b87300 !important;
}
.chip-completed {
	background: #e7f6ec !important;
	color: #2e9e5b !important;
}

@media (max-width: 600px) {
	.form-row {
		flex-wrap: wrap;
	}
	.form-row__main {
		width: 100%;
		margin-top: 10px;
		flex-basis: 100%;
	}
	.form-row > div.ml-4 {
		margin-left: 0 !important;
		margin-top: 14px;
		width: 100%;
	}
	.form-row > div.ml-4 .v-btn {
		width: 100%;
	}
}
</style>